import { render, staticRenderFns } from "./individualOT.vue?vue&type=template&id=522f61eb&"
import script from "./individualOT.vue?vue&type=script&lang=js&"
export * from "./individualOT.vue?vue&type=script&lang=js&"
import style0 from "./individualOT.vue?vue&type=style&index=0&id=522f61eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports